import getToken from '../../app/util/getToken'

async function prepareHeaders(headers) {
  headers.set('Authorization', await getToken())
  return headers
}

export default prepareHeaders
